// extracted by mini-css-extract-plugin
module.exports = {"item":"breadcrumbItem_item__18o81","link":"breadcrumbItem_link__31nXs"};